import React from 'react';
import _ from 'lodash';
import ReactMarkdown from 'react-markdown/with-html';
import { buildImageObj, imageUrlFor } from './sanity/image-url';
import SocialLinks from './social/social-links';
// import CompanyItem from './company-item';
// import BlogTeaser from './blog-teaser';

function PeopleFull(props) {
    const { language, body, image } = props;
    // let currentCompanies = _.get(props, 'currentCompanies', []).filter(company => !_.get(company, 'categories', []).some(category => category.categoryTitle === 'Alumni'));
    // let priorCompanies = _.get(props, 'priorCompanies', []).filter(company => _.get(company, 'categories', []).some(category => category.categoryTitle !== 'Alumni'));
    // let alumniCompanies = _.get(props, 'currentCompanies', []).filter(company => _.get(company, 'categories', []).some(category => category.categoryTitle === 'Alumni'));
    // let categories = _.get(props, 'categories', []);

    let grid_class = 'col-sm-8 col-lg-7 offset-sm-2';
    let gutter_class = '';
    let name_class = 'offset-sm-2 offset-md-0';

    // if (currentCompanies.length || priorCompanies.length || alumniCompanies.length) {
    //     grid_class = 'col-sm-8 col-lg-6 offset-lg-1';
    //     gutter_class = 'gutter-left';
    //     name_class = '';
    // }

    const overrideImgStyles = {
        maxHeight: '534px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
    }

    return (
        <section className="container partner h-card">
            <div className="row">
                <div className="col-12">
                    <div className="partner__img-lockup">
                        <figure className="partner__media" style={overrideImgStyles}>
                            {props.image && props.image.asset && (
                                <img
                                    className="partner__img u-photo"
                                    alt={props.name[language]}
                                    src={imageUrlFor(buildImageObj(image))
                                    }/>
                            )}
                        </figure>
                        <header className="partner__info vcard">
                            <div>
                                {props.name && (
                                    <h1 className={`fn p-name ${name_class}`}>
                                        {props.name[language]}
                                    </h1>
                                )}
                                <div className="social-buttons">
                                    <SocialLinks email={props.email} linkedinUrl={props.linkedinUrl} twitterUrl={props.twitterUrl} />
                                </div>
                            </div>
                        </header>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className={`${grid_class}`}>
                    <div className={`partner__bio ${gutter_class}`}>
                        <div className="fw--300">
                            {body && <ReactMarkdown source={body[language]} escapeHtml={false} />}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PeopleFull;
